<template>
    <v-container fluid fill-height class="flex-column justify-center">
        <v-card 
            color="white"
            class="mx-auto"
            width="400px"
            max-width="550"
            elevation="3"
        >
            <v-card-title class="justify-center" v-text="$t('PageNotFoundTitle')"></v-card-title>
            <v-card-subtitle class="text-center mb-4" v-text="$t('PageNotFoundDescription')"></v-card-subtitle>
            <v-card-text class="text-center">
                <v-btn rounded depressed to="/">
                    <v-icon left>mdi-arrow-left</v-icon> 
                    {{ $t('BackToHomePage') }}
                </v-btn>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    export default {
        name: 'notFound'
    }
</script>

<style lang="scss" scoped>
.container--fluid{
    background-image: url('~@/assets/images/landing-page.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    .class-logo{
        display: block;
        max-width: 100%;
        height: 135px;
        margin: 0 auto;
    }
}
</style>